import { Observable } from "rxjs";

import { ArchivoAdjuntoResponseModel } from "../archivo-adjunto-response.model";
import { ArchivoAdjuntoUpload, ArchivoAdjuntoUploadResponseModel } from "../archivo-adjunto-upload.model";

export abstract class ArchivoAdjuntoGateway {
    abstract ObtenerUrl(data: string): Observable<ArchivoAdjuntoResponseModel>;
    abstract upload(data: ArchivoAdjuntoUpload): Observable<ArchivoAdjuntoUploadResponseModel>;    
}